var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "480px",
    height: "680px",
    viewBox: "0 0 480 680",
    enableBackground: "new 0 0 480 680",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.2505,
    y1: -321.25,
    x2: 811.7505,
    y2: 259.2502,
    gradientTransform: "matrix(1 0 0 -1 -282 309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3168,
    style: {
      stopColor: "#D5D6D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6415,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#DBE6E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    style: {
      stopColor: "#E9E9EA"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    fill: "url(#SVGID_1_)",
    width: 481,
    height: 680
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M199.891,0H0v476.369c6.75,0.501,13.567,0.762,20.446,0.762 c150.396,0,272.316-121.92,272.316-272.315C292.762,123.161,256.813,49.912,199.891,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M482,355.718c-70.47-127.059-205.967-213.064-361.554-213.064 c-41.532,0-81.631,6.134-119.446,17.536V680h481V355.718z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground01);
export default __webpack_public_path__ + "static/media/background_01.dc1be95a4b71bd1945117841d8ae9edf.svg";
export { ForwardRef as ReactComponent };